import { amazonDataTypes } from "./amazon";
import { metaDataTypes } from "./meta";
import { googleDataTypes } from "./google";
import { packageData, genericDataTypes } from "./generic";
import { lyftDataTypes } from "./lyft";
import { twitterDataTypes } from "./twitter";
import { pinterestDataTypes } from "./pinterest";
import { redditDataTypes } from "./reddit";
import { itvDataTypes } from "./itv";
import { microsoftDataTypes } from "./microsoft";
import { walmartDataTypes } from "./walmart";
import { googleTakeoutMultiDataTypes } from "./google-multi";
import { youtubeDataTypes } from "./youtube";
import { targetDataTypes } from "./target";
import { appleDataTypes } from "./apple";
import { valveDataTypes } from "./valve";
import { bytedanceDataTypes } from "./bytedance";
import { netflixDataTypes } from "./netflix";
import { instacartDataTypes } from "./instacart";
import { uberDataTypes } from "./uber";
import { doordashDataTypes } from "./doordash";
import { chatGPTDataTypes } from "./chatgpt";
import { spotifyDataTypes } from "./spotify";
import { huluDataTypes } from "./hulu";
import { tescoDataTypes} from "./tesco";
import {bookingDataTypes} from "./booking";
import { perplexityDataTypes } from "./perplexity";
import { robloxDataTypes } from "./roblox";

const dataTypes = {
    ...amazonDataTypes,
    ...appleDataTypes,
    ...bytedanceDataTypes,
    ...doordashDataTypes,
    ...genericDataTypes,
    ...googleDataTypes,
    ...instacartDataTypes,
    ...itvDataTypes,
    ...lyftDataTypes,
    ...metaDataTypes,
    ...microsoftDataTypes,
    ...netflixDataTypes,
    ...perplexityDataTypes,
    ...pinterestDataTypes,
    ...redditDataTypes,
    ...robloxDataTypes,
    ...targetDataTypes,
    ...twitterDataTypes,
    ...uberDataTypes,
    ...valveDataTypes,
    ...walmartDataTypes,
    ...googleTakeoutMultiDataTypes,
    ...youtubeDataTypes,
    ...chatGPTDataTypes,
    ...spotifyDataTypes,
    ...huluDataTypes,
    ...tescoDataTypes,
    ...bookingDataTypes
};


export default function formatInstructionsByDataType(dataType, platform, lang, showSimpleInstructions) {
    return packageData(dataTypes[dataType], platform, lang, showSimpleInstructions);
}